module.exports = __webpack_public_path__ + "static/media/analysis.8c5ea7e8.svg";